import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { createRoot } from 'react-dom/client';
import { TelemetryErrorBoundary } from './telemetry';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

root.render(
    <TelemetryErrorBoundary>
            <BrowserRouter basename={baseUrl ?? undefined}>
                <App />
            </BrowserRouter>
    </TelemetryErrorBoundary>
);
